// import React from "react";
// import pic1 from "../../Assets/card.JPG";
// import pic2 from "../../Assets/card.JPG";
// import pic3 from "../../Assets/card.JPG";
// import pic4 from "../../Assets/card.JPG";

// const Section7 = () => {
//   const steps = [
//     {
//       number: "ONE",
//       title: "INQUIRY FORM",
//       description:
//         "Once you've read over our packages and pricing, complete our inquiry form with your information. You'll hear back from us within 48 business hours.",
//       image: pic1,
//     },
//     {
//       number: "TWO",
//       title: "DISCOVERY CALL",
//       description:
//         "We will reach out to schedule a discovery call to ensure we are a good fit and aligned with your vision. We will go over our packages and determine the perfect fit for you.",
//       image: pic2,
//     },
//     {
//       number: "THREE",
//       title: "CONTRACT / AGREEMENT",
//       description:
//         "If we're the perfect fit (yay!) we'll send over a contract and proposal for you to complete. Once it is signed, you'll officially be our client!",
//       image: pic3,
//     },
//     {
//       number: "FOUR",
//       title: "ONBOARDING",
//       description:
//         "Pop the champagne! This is where we'll begin the onboarding process. You'll receive a welcome email with the next steps.",
//       image: pic4,
//     },
//   ];

//   return (
//     <section className="w-full bg-[#F2EFEA] px-32 py-10">
//       <div className="max-w-[1400px] mx-auto">
//         <div className="text-center mb-10">
//           <h2
//             className="text-3xl md:text-5xl font-extralight tracking-wide"
//             style={{
//               fontFamily: "Blacker Pro Display",
//             }}
//           >
//             READY TO WORK TOGETHER?
//           </h2>

//           <h2
//             className="text-3xl md:text-4xl italic tracking-wide mt-2"
//             style={{
//               fontFamily: "Blacker Pro Display",
//             }}
//           >
//             HERE'S{" "}
//             <span
//               className="text-3xl md:text-4xl text-[#704735] italic tracking-wide mt-2"
//               style={{
//                 fontFamily: "Blacker Pro Display",
//               }}
//             >
//               OUR PROCESS.
//             </span>
//           </h2>
//         </div>

//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
//           {steps.map((step, index) => (
//             <div key={index} className="flex flex-col">
//               <div className="relative h-44 md:h-72 mb-6">
//                 <img
//                   src={step.image}
//                   alt={`Process step ${step.number}`}
//                   className="w-full h-full object-cover "
//                 />
//               </div>
//               <div className="flex flex-col h-40">
//                 {/* Fixed height container for title and spacing */}
//                 <h3
//                   className="text-xl md:text-2xl font-extralight tracking-wider h-16"
//                   style={{
//                     fontFamily: "Blacker Pro Display",
//                   }}
//                 >
//                   {/* Fixed height for title */}
//                   STEP {step.number}- <span className="">{step.title}</span>
//                 </h3>
//                 <p
//                   className="text-base text-gray-600 text-justify leading-relaxed  "
//                   style={{
//                     fontFamily: "Lato-Regular",
//                   }}
//                 >
//                   {step.description}
//                 </p>
//               </div>
//             </div>
//           ))}
//         </div>

//         <div className="text-center mt-16">
//           <button className="bg-[#704735] text-white px-8 py-4 rounded-md text-sm cursor-pointer self-center tracking-widest">
//             INQUIRE WITH US
//           </button>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Section7;

import React from "react";
import pic1 from "../../Assets/ContentCreation.jpg";
import pic2 from "../../Assets/SocialMedia.jpg";
import pic3 from "../../Assets/card.JPG";
import pic4 from "../../Assets/branding.jpg";

import { Link } from "react-router-dom";

const Section7 = () => {
  const steps = [
    {
      number: "ONE",
      title: "INQUIRY FORM",
      description:
        "Once you've read over our packages and pricing, complete our inquiry form with your information. You'll hear back from us within 48 business hours.",
      image: pic1,
    },
    {
      number: "TWO",
      title: "DISCOVERY CALL",
      description:
        "We will reach out to schedule a discovery call to ensure we are a good fit and aligned with your vision. We will go over our packages and determine the perfect fit for you.",
      image: pic2,
    },
    {
      number: "THREE",
      title: "CONTRACT / AGREEMENT",
      description:
        "If we're the perfect fit (yay!) we'll send over a contract and proposal for you to complete. Once it is signed, you'll officially be our client!",
      image: pic3,
    },
    {
      number: "FOUR",
      title: "ONBOARDING",
      description:
        "Pop the champagne! This is where we'll begin the onboarding process. You'll receive a welcome email with the next steps.",
      image: pic4,
    },
  ];

  return (
    <section className="w-full bg-[#F2EFEA] px-4 sm:px-8 md:px-16 lg:px-32 py-10">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2
            className="text-3xl md:text-5xl font-extralight tracking-wide"
            style={{
              fontFamily: "Blacker Pro Display",
            }}
          >
            READY TO WORK TOGETHER?
          </h2>

          <h2
            className="text-3xl md:text-4xl italic tracking-wide mt-2"
            style={{
              fontFamily: "Blacker Pro Display",
            }}
          >
            HERE'S{" "}
            <span
              className="text-3xl md:text-4xl text-[#704735] italic tracking-wide mt-2"
              style={{
                fontFamily: "Blacker Pro Display",
              }}
            >
              OUR PROCESS.
            </span>
          </h2>
        </div>

        {/* <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">
          {steps.map((step, index) => (
            <div key={index} className="flex flex-col">
              <div className="relative h-56 sm:h-64 md:h-72 mb-6">
                <img
                  src={step.image}
                  alt={`Process step ${step.number}`}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex flex-col min-h-[160px] md:h-40">
                <h3
                  className="text-xl md:text-2xl font-extralight tracking-wider mb-4 md:h-16"
                  style={{
                    fontFamily: "Blacker Pro Display",
                  }}
                >
                  STEP {step.number}- <span>{step.title}</span>
                </h3>
                <p
                  className="text-base text-gray-600 text-justify leading-relaxed"
                  style={{
                    fontFamily: "Lato-Regular",
                  }}
                >
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div> */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">
          {steps.map((step, index) => (
            <div key={index} className="flex flex-col">
              <div className="relative h-56 sm:h-64 md:h-72 mb-6">
                <img
                  src={step.image}
                  alt={`Process step ${step.number}`}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex flex-col flex-1">
                <h3
                  className="text-xl md:text-2xl font-extralight tracking-wider mb-4 min-h-[48px]"
                  style={{
                    fontFamily: "Blacker Pro Display",
                  }}
                >
                  STEP {step.number}- <span>{step.title}</span>
                </h3>
                <p
                  className="text-base text-gray-600 text-justify leading-relaxed flex-1"
                  style={{
                    fontFamily: "Lato-Regular",
                  }}
                >
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-4 md:mt-10 lg:mt-20 sm:mt-20">
          <Link to="/contact">
            <button className="bg-[#704735] text-white px-8 py-4 rounded-md text-sm cursor-pointer self-center tracking-widest">
              CONNECT WITH US
            </button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Section7;
